import { useEffect, useState } from "react";
import {
  Button,
  TextField,
  Grid,
  Paper,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import WorkshopService from "../../services/workshop.service";
import ProfileService from "../../services/profile.service";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useUpload } from "../../hooks/useUpload";
import axiosInstance from "../../modules/axiosInstance";
import LiveCategoriesService from "../../services/liveCategories.service";

const Lives = ({ handleClose }) => {
  const { upload, isUploading, progress } = useUpload();
  const [formData, setFormData] = useState({
    title: "",
    thumbnail: null,
    video: null,
    category: "",
    workshop: "",
    date: "",
    profesionals: [],
    workshopNumber: null,
  });
  const [workshopsList, setWorkshopsList] = useState([]);
  const [profesionals, setProfesionals] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const getWorkshops = async () => {
      try {
        const response = await WorkshopService.getAllWorkshops();
        if (!response.error) {
          setWorkshopsList(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const getProfesionals = async () => {
      try {
        const response = await ProfileService.getProfiles();
        if (!response.error) {
          setProfesionals(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const getCategories = async () => {
      try {
        const response = await LiveCategoriesService.getAll();
        setCategories(response || []);
      } catch (error) {
        console.error(error);
      }
    };

    getWorkshops();
    getProfesionals();
    getCategories();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.thumbnail) {
      alert("Debes subir una imagen de portada.");
      return;
    }
    if (!formData.video) {
      alert("Debes subir un video.");
      return;
    }

    const workshop = workshopsList.find((w) => w.id === formData.workshop);
    formData.workshopNumber = workshop ? workshop.workshopNumber : null;

    try {
      const { ok, live } = await upload({ formData });
      // console.log("ok---->", ok)
      // console.log("live---->", live)
      if (ok) {
        await axiosInstance.post("api/lives", {
          live,
          profesionalsIDs:
            typeof formData.profesionals === "number"
              ? formData.profesionals
              : null,
        });
        // console.log("res---->", res)
      }

      // reset
      setFormData({
        title: "",
        thumbnail: null,
        video: null,
        category: "",
        workshop: "",
        date: "",
        profesionals: [],
        workshopNumber: null,
      });
      handleClose();
    } catch (err) {
      console.error(err);
      alert(err?.message || "Error subiendo el vivo");
    }
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ minHeight: "100vh" }}
    >
      <Grid item xs={12} sm={10} md={8} lg={6}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 4 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h4" fontWeight={600}>
              Nuevo Vivo
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon color="primary" />
            </IconButton>
          </Box>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  label="Título"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  fullWidth
                  required
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <input
                  accept="image/*"
                  style={{ display: "none" }}
                  id="thumbnail-upload"
                  type="file"
                  name="thumbnail"
                  onChange={handleFileChange}
                />
                <label htmlFor="thumbnail-upload">
                  <Box
                    sx={{
                      border: "2px dashed #ccc",
                      borderRadius: 2,
                      p: 2,
                      textAlign: "center",
                      cursor: "pointer",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <CloudUpload fontSize="large" color="action" />
                    <Typography variant="body2">Subir Portada</Typography>
                    {formData.thumbnail && (
                      <Typography variant="caption" color="text.secondary">
                        {formData.thumbnail.name}
                      </Typography>
                    )}
                  </Box>
                </label>
              </Grid>

              <Grid item xs={12} sm={6}>
                <input
                  accept="video/*"
                  style={{ display: "none" }}
                  id="video-upload"
                  type="file"
                  name="video"
                  onChange={handleFileChange}
                />
                <label htmlFor="video-upload">
                  <Box
                    sx={{
                      border: "2px dashed #ccc",
                      borderRadius: 2,
                      p: 2,
                      textAlign: "center",
                      cursor: "pointer",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <CloudUpload fontSize="large" color="action" />
                    <Typography variant="body2">Subir Video</Typography>
                    {formData.video && (
                      <Typography variant="caption" color="text.secondary">
                        {formData.video.name}
                      </Typography>
                    )}
                  </Box>
                </label>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth required>
                  <InputLabel id="category-label">Categoría</InputLabel>
                  <Select
                    labelId="category-label"
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    label="Categoría"
                  >
                    <MenuItem value="" disabled>
                      Selecciona una categoría
                    </MenuItem>
                    {categories.map((category) => (
                      <MenuItem key={category.id} value={category.id}>
                        {category.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="profesionals-label">Profesional</InputLabel>
                  <Select
                    labelId="profesionals-label"
                    name="profesionals"
                    value={formData.profesionals}
                    onChange={handleChange}
                    label="Profesional"
                  >
                    <MenuItem value="">Ninguno</MenuItem>
                    {profesionals.map((p) => (
                      <MenuItem key={p.id} value={p.id}>
                        {p.name} {p.lastname}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Taller</InputLabel>
                  <Select
                    name="workshop"
                    value={formData.workshop}
                    onChange={handleChange}
                    label="Taller"
                  >
                    <MenuItem value="">Ninguno</MenuItem>
                    {workshopsList
                      .slice()
                      .sort((a, b) => a.workshopNumber - b.workshopNumber)
                      .map((w) => (
                        <MenuItem key={w.id} value={w.id}>
                          Taller número {w.workshopNumber}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Fecha"
                  name="date"
                  type="date"
                  value={formData.date}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  size="large"
                  disabled={isUploading}
                >
                  {isUploading ? `Subiendo... ${progress}%` : "Enviar"}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Grid>
    </Grid>
  );
};
export default Lives;
